/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_DescriptionInputs */

const en_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed an audio description track into an existing media file. Video and metadata are copied without transcoding.`)
};

const fr_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrez une piste de description audio dans un fichier multimédia existant. La vidéo et les métadonnées sont copiées sans transcodage.`)
};

const de_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Audiobeschreibungsspur wird in eine bestehende Mediendatei eingebettet. Video und Metadaten werden ohne Transkodierung kopiert.`)
};

const it_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora una traccia di descrizione audio in un file multimediale esistente. Video e metadati vengono copiati senza transcodifica.`)
};

const ru_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание аудиодорожки с описанием в существующий медиафайл. Видео и метаданные копируются без перекодирования.`)
};

const es_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserta una pista de audiodescripción en un archivo multimedia existente. El vídeo y los metadatos se copian sin transcodificación.`)
};

const zh_cn2_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将音频描述轨道嵌入到现有媒体文件中。视频和元数据无需转码即可复制。`)
};

const ja_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既存のメディアファイルに音声解説トラックを埋め込みます。ビデオとメタデータはトランスコードせずにコピーされます。`)
};

const hi_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किसी मौजूदा मीडिया फ़ाइल में ऑडियो विवरण ट्रैक एम्बेड करें। वीडियो और मेटाडेटा को बिना ट्रांसकोडिंग के कॉपी किया जाता है।`)
};

const pt_pt2_audio_embed_export_description = /** @type {(inputs: Audio_Embed_Export_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpore uma faixa de descrição de áudio em um arquivo de mídia existente. O vídeo e os metadados são copiados sem transcodificação.`)
};

/**
* | output |
* | --- |
* | "Embed an audio description track into an existing media file. Video and metadata are copied without transcoding." |
*
* @param {Audio_Embed_Export_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_description = /** @type {((inputs?: Audio_Embed_Export_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_description(inputs)
	if (locale === "de") return de_audio_embed_export_description(inputs)
	if (locale === "it") return it_audio_embed_export_description(inputs)
	if (locale === "ru") return ru_audio_embed_export_description(inputs)
	if (locale === "es") return es_audio_embed_export_description(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_description(inputs)
	if (locale === "ja") return ja_audio_embed_export_description(inputs)
	if (locale === "hi") return hi_audio_embed_export_description(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_description(inputs)
	return en_audio_embed_export_description(inputs)
});